import { useCallback, useEffect, useRef, useState } from "react";
import styles from "./PlanCarousel.module.css";

export default function PlanCarousel({ children, centered }) {
    const trackRef = useRef(null);
    const [canScrollPrev, setCanScrollPrev] = useState(false);
    const [canScrollNext, setCanScrollNext] = useState(false);

    const updateScrollState = useCallback(() => {
        const el = trackRef.current;
        if (!el) return;
        setCanScrollPrev(el.scrollLeft > 1);
        setCanScrollNext(el.scrollLeft < el.scrollWidth - el.clientWidth - 1);
    }, []);

    useEffect(() => {
        updateScrollState();
        window.addEventListener('resize', updateScrollState);
        return () => window.removeEventListener('resize', updateScrollState);
    }, [updateScrollState]);

    const scrollByCard = (direction) => {
        const el = trackRef.current;
        if (!el) return;
        const card = el.firstElementChild;
        const gap = parseFloat(getComputedStyle(el).columnGap || '18') || 18;
        const step = card ? card.getBoundingClientRect().width + gap : el.clientWidth * 0.8;
        el.scrollBy({ left: direction * step, behavior: 'smooth' });
    };

    return (
        <div className={styles.carouselWrap}>
            <button
                type="button"
                className={`${styles.navBtn} ${styles.prev}`}
                onClick={() => scrollByCard(-1)}
                disabled={!canScrollPrev}
                aria-label="Previous plans"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="15 18 9 12 15 6"></polyline></svg>
            </button>

            <div className={`${styles.carousel} ${centered ? styles.centered : ''}`} ref={trackRef} onScroll={updateScrollState}>
                {children}
            </div>

            <button
                type="button"
                className={`${styles.navBtn} ${styles.next}`}
                onClick={() => scrollByCard(1)}
                disabled={!canScrollNext}
                aria-label="Next plans"
            >
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round"><polyline points="9 18 15 12 9 6"></polyline></svg>
            </button>
        </div>
    );
}
